export default [{
    path: '/admin/family_role/list',
    name: 'FamilyRole',
    component: () => import('../views/healthy/family/familyRole'),
    meta: {
      title: '家庭角色',
      keepAlive: false
    }
  },
  {
    path: '/admin/family/list',
    name: 'FamilyList',
    component: () => import('../views/healthy/family/familyList'),
    meta: {
      title: '家庭列表',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/news/category',
    name: 'NewsCategory',
    component: () => import('../views/healthy/news/newsCategory'),
    meta: {
      title: '健康百科-文章分类',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/news/list',
    name: 'NewsList',
    component: () => import('../views/healthy/news/newsList'),
    meta: {
      title: '健康百科-文章列表',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/news/edit',
    name: 'newsEdit',
    component: () => import('../views/healthy/news/editNews'),
    meta: {
      title: '健康百科-编辑文章',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/manage/healthy_data',
    name: 'healthyData',
    component: () => import('../views/healthy/manage/health_data'),
    meta: {
      title: '健康管理-健康数据',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/manage/healthy_upload',
    name: 'healthyUpload',
    component: () => import('../views/healthy/manage/healthy_upload'),
    meta: {
      title: '健康管理-健康上传',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/manage/xueya',
    name: 'Xueya',
    component: () => import('../views/healthy/manage/xueya/xueya'),
    meta: {
      title: '健康管理-血压',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/video/list',
    name: 'videoList',
    component: () => import('../views/healthy/video/list'),
    meta: {
      title: '健康百科-健康视频',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/manage/xuetang',
    name: 'Xuetang',
    component: () => import('../views/healthy/manage/xuetang/xuetang'),
    meta: {
      title: '健康管理-血糖',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/manage/heart',
    name: 'Heart',
    component: () => import('../views/healthy/manage/heart/heart'),
    meta: {
      title: '健康管理-心率',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/manage/sleep',
    name: 'Sleep',
    component: () => import('../views/healthy/manage/sleep/sleep'),
    meta: {
      title: '健康管理-睡眠',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/manage/weight',
    name: 'Weight',
    component: () => import('../views/healthy/manage/weight/weight'),
    meta: {
      title: '健康管理-体重',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/manage/animal',
    name: 'Animal',
    component: () => import('../views/healthy/manage/animal/animal'),
    meta: {
      title: '健康管理-体温',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/news/healthy_classroom',
    name: 'Healthy_classroom',
    component: () => import('../views/healthy/news/healthy_classroom'),
    meta: {
      title: '健康百科-健康小课堂',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/news/food_therapy',
    name: 'FoodTherapy',
    component: () => import('../views/healthy/news/food_therapy'),
    meta: {
      title: '健康百科-健康食疗',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/news/food_category',
    name: 'FoodCategory',
    component: () => import('../views/healthy/news/food_category'),
    meta: {
      title: '健康百科-健康食疗',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/manage/family_data',
    name: 'FamilyData',
    component: () => import('../views/healthy/manage/family_data'),
    meta: {
      title: '健康管理-健康数据-家人数据',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/ai/list',
    name: 'AiList',
    component: () => import('../views/healthy/ai/list'),
    meta: {
      title: '健康AI-设置',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/ai/record',
    name: 'AiRecord',
    component: () => import('../views/healthy/ai/record'),
    meta: {
      title: '健康AI-记录',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/manage/xueyang',
    name: 'ManageXueyang',
    component: () => import('../views/healthy/manage/xueyang/xueyang'),
    meta: {
      title: '健康管理-血氧',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/manage/lithic',
    name: 'ManageLithic',
    component: () => import('../views/healthy/manage/lithic/lithic'),
    meta: {
      title: '健康管理-尿酸',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/ai/distribution/BasicSet',
    name: 'AiBasic',
    component: () => import('../views/healthy/ai/distribution/basic_set'),
    meta: {
      title: '健康AI-分销设置',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/ai/distribution/List',
    name: 'AiDistributionList',
    component: () => import('../views/healthy/ai/distribution/list'),
    meta: {
      title: '健康AI-分销商管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/ai/distribution/order',
    name: 'AidistributionOrder',
    component: () => import('../views/healthy/ai/distribution/order'),
    meta: {
      title: '健康AI-分销订单',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/ai/distribution/withdrawal',
    name: 'AidistributionWithdrawal',
    component: () => import('../views/healthy/ai/distribution/withdrawal'),
    meta: {
      title: '健康AI-提现管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/ai/order',
    name: 'AiOrder',
    component: () => import('../views/healthy/ai/order'),
    meta: {
      title: '健康AI-订单记录',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/healthy_video/list',
    name: 'HealthyVideoList',
    component: () => import('../views/healthy/healthy_video/list'),
    meta: {
      title: '健康百科-健康视频',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/healthy_video/classify_list',
    name: 'HealthyVideoClassifyList',
    component: () => import('../views/healthy/healthy_video/classify_list'),
    meta: {
      title: '健康百科-健康视频分类',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/ai/issue_answer',
    name: 'HealthyAiIssueAnswer',
    component: () => import('../views/healthy/ai/issue_answer/list'),
    meta: {
      title: '健康百科-健康视频分类',
      keepAlive: false
    }
  },
  {
    path: '/admin/healthy/ai/recommend',
    name: 'HealthyAiRecommendIndex',
    component: () => import('../views/healthy/ai/recommend/index'),
    meta: {
      title: '产品推荐',
      keepAlive: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/healthy.js